<template>
  <FullscreenPopup
    v-if="visible"
    :title="$t('_web_nointernet_title', 'No Internet Connection')"
    :sub-title="
      $t(
        '_web_nointernet_subtitle',
        'Slow or not internet connection. Please check your Internet settings.'
      )
    "
    error-popup
  >
    <!-- SVG inlined becouse its must work offline -->
    <svg
      slot="image"
      width="43"
      height="36"
      viewBox="0 0 43 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.5566 15.1156C25.5566 16.884 24.3579 18.3636 22.717 18.87V34.8132C22.717 35.4699 22.1714 36 21.5 36C20.8286 36 20.283 35.4679 20.283 34.8132V18.87C18.6421 18.3636 17.4434 16.884 17.4434 15.1156C17.4434 12.9299 19.2587 11.1595 21.5 11.1595C23.7413 11.1595 25.5566 12.9299 25.5566 15.1156ZM30.962 5.91762C30.4894 5.45476 29.7146 5.45673 29.242 5.92158C28.7674 6.38642 28.7694 7.13809 29.2461 7.60095C31.315 9.60869 32.4528 12.2771 32.4528 15.1156C32.4528 17.9541 31.3129 20.6245 29.2461 22.6323C28.7694 23.0951 28.7674 23.8468 29.242 24.3116C29.4793 24.545 29.7917 24.6617 30.1041 24.6617C30.4144 24.6617 30.7267 24.547 30.962 24.3156C33.4933 21.8588 34.8868 18.5911 34.8868 15.1156C34.8868 11.6402 33.4933 8.3724 30.962 5.91762ZM13.758 5.92158C13.2833 5.45673 12.5126 5.45673 12.0359 5.91762C9.50665 8.3724 8.11321 11.6402 8.11321 15.1136C8.11321 18.5891 9.50665 21.8569 12.0359 24.3136C12.2733 24.5431 12.5836 24.6598 12.8939 24.6598C13.2063 24.6598 13.5186 24.5431 13.7559 24.3097C14.2306 23.8448 14.2285 23.0931 13.7519 22.6303C11.683 20.6225 10.5451 17.9522 10.5451 15.1136C10.5451 12.2731 11.683 9.60473 13.7519 7.59898C14.2306 7.13611 14.2326 6.38445 13.758 5.92158ZM36.7021 0.34542C36.2255 -0.115469 35.4547 -0.115469 34.9801 0.349376C34.5055 0.81422 34.5075 1.56588 34.9821 2.02875C38.5824 5.52597 40.566 10.1724 40.566 15.1176C40.566 20.0608 38.5824 24.7092 34.9821 28.2045C34.5075 28.6673 34.5055 29.419 34.9801 29.8838C35.2174 30.1172 35.5298 30.2339 35.8421 30.2339C36.1525 30.2339 36.4648 30.1172 36.7021 29.8878C40.7628 25.9416 43 20.6977 43 15.1176C43.002 9.5355 40.7628 4.28968 36.7021 0.34542ZM2.43396 15.1156C2.43396 10.1705 4.41764 5.52399 8.01585 2.02677C8.4925 1.56391 8.49453 0.812242 8.01991 0.347398C7.54528 -0.115469 6.77453 -0.115469 6.29788 0.34542C2.23722 4.28968 0 9.5355 0 15.1156C0 20.6938 2.23722 25.9396 6.29788 29.8858C6.53519 30.1153 6.84552 30.232 7.15585 30.232C7.46821 30.232 7.78057 30.1153 8.01788 29.8819C8.4925 29.417 8.49047 28.6653 8.01382 28.2025C4.41764 24.7072 2.43396 20.0588 2.43396 15.1156Z"
        fill="white"
      />
    </svg>
    <form slot="footer" @submit.prevent="check">
      <HeraFormSubmitBtn
        :tabindex="0"
        :label="$t('_web_nointernet_retry_btn', 'Retry')"
        class="btn-primary font-size-sm offline-popup__button"
      />
    </form>
  </FullscreenPopup>
</template>

<script>
import FullscreenPopup from '@/components/popup/FullscreenPopup';
import HeraFormSubmitBtn from '@/components/form/HeraFormSubmitBtn';

export default {
  name: 'OfflinePopup',

  components: { FullscreenPopup, HeraFormSubmitBtn },

  data() {
    return {
      online: true,
    };
  },

  computed: {
    visible() {
      return !this.online && !localStorage.getItem('hideOfflinePopup');
    },
  },

  mounted() {
    window.addEventListener('online', this.onlineHandler);
    window.addEventListener('offline', this.offlineHandler);
  },

  beforeDestroy() {
    window.removeEventListener('online', this.onlineHandler);
    window.removeEventListener('offline', this.offlineHandler);
  },

  methods: {
    check() {
      if (window.navigator.onLine) {
        this.onlineHandler();
      }
    },

    onlineHandler() {
      this.online = true;
    },

    offlineHandler() {
      this.online = false;
    },
  },
};
</script>
